"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _icons = require("../../../static/icons/icons");

var _style = require("./style");

var _index = _interopRequireDefault(require("../Icon/index"));

var AirportItem = function AirportItem(_ref) {
  var airportCode = _ref.airportCode,
      city = _ref.city,
      country = _ref.country,
      featured = _ref.featured,
      icon = _ref.icon,
      name = _ref.name,
      onMouseDown = _ref.onMouseDown,
      selected = _ref.selected,
      topPosition = _ref.topPosition;
  return _react["default"].createElement(_style.Wrapper, {
    featured: featured,
    onMouseDown: onMouseDown,
    selected: selected,
    topPosition: topPosition
  }, _react["default"].createElement(_style.Container, null, _react["default"].createElement(_index["default"], {
    icon: icon,
    size: 16
  }), _react["default"].createElement(_style.TextContainer, null, _react["default"].createElement(_style.Text, null, "".concat(city, " - "), _react["default"].createElement("span", null, "".concat(name, " (").concat(airportCode, ")"))), _react["default"].createElement(_style.Country, null, country))), _react["default"].createElement(_style.Separator, null));
};

AirportItem.propTypes = {
  airportCode: _propTypes["default"].string,
  city: _propTypes["default"].string,
  country: _propTypes["default"].string,
  featured: _propTypes["default"].bool,
  icon: _propTypes["default"].string,
  name: _propTypes["default"].string,
  onMouseDown: _propTypes["default"].func,
  selected: _propTypes["default"].bool,
  topPosition: _propTypes["default"].number
};
AirportItem.defaultProps = {
  airportCode: null,
  city: null,
  country: null,
  featured: false,
  icon: _icons.ICONS.AIRFILLUP,
  name: null,
  onMouseDown: null,
  selected: false,
  topPosition: null
};
var _default = AirportItem;
exports["default"] = _default;